import { convertSanityRefToShopifyProductNumber } from "../../utils/sanity";
import { fetchWithMemoryCache } from "../../utils/cache/memory";
import { createHashKey } from "../../utils";
import { SanityApi } from "../sanity";
import { getShopifyProductIdsFromSanityDocuments } from "../sanity/helpers";
import { clientFetch } from "../sanity/resource/helpers";
import { simpleProductsByIds, productById } from "../shopify/product";
import { fetchLayout } from "./layout";
import { withCountryCode, withIds } from "../../types/fetch";
import { sanity } from "../";
import { constructStaticPathsFromHandles } from "../../utils/paths";

export const fetchShopifyProducts = ({ids, countryCode}: withIds & withCountryCode) => {
  const fetcher = () => simpleProductsByIds(ids, { countryCode, });
  const key = createHashKey('fetchShopifyProducts', {ids, countryCode});
  return fetchWithMemoryCache(key, fetcher);
};

export const fetchSanityProducts = ({ids}: withIds) => {
  const fetcher = () => sanity.products.fetchByIds({ ids, })
  const key = createHashKey('fetchShopifyProducts', {ids});
  return fetchWithMemoryCache(key, fetcher);
}


export const fetchProductPage = ({
  locale,preview,handle
}: any) => {
  const fetcher = async () => {
    const layout = await fetchLayout({locale, isPreview: preview})
    if(!handle || handle == 'error') throw new Error();

    // Sanity Content
    const product = await SanityApi.products.fetchByHandle({ handle, isPreview: preview });
    if(!product) throw new Error(`${handle} not found`);

    const shopifyId = convertSanityRefToShopifyProductNumber(product._id);
    const shopifyIds = getShopifyProductIdsFromSanityDocuments([ layout, product ])
      .filter((id) => id != shopifyId);
    const countryCode = locale?.toUpperCase() || 'NZ';
    
    const shopifyProducts = await simpleProductsByIds(shopifyIds, {countryCode});  

    // Fetch the product itself using proper fetch
    const shopifyProduct = await productById(shopifyId, {countryCode})

    if(!shopifyProduct) throw new Error(`${handle} shopify product not found`);

    return { 
      handle,
      layout,
      preview, 
      product,
      shopifyProduct,
      shopifyProducts,
      locale,
    };
  }

  const key = createHashKey('fetchProductPage', {locale,handle,preview})
  return preview ? fetcher() : fetchWithMemoryCache(key, fetcher)
}

export const fetchProductPaths = async ({locales}) => {
  const resources = await clientFetch({
    query: /*groq*/`
      *[_type == "product"][0...500] {
        "handle": store.slug.current
      }
    `
  });

  const handles = resources.map((resource: any) => (resource.handle.toString()))
  return constructStaticPathsFromHandles({locales,handles});
}